export default class UnavailableDateError {
	suggestedDates: Date[];

	constructor(suggestedDates: Date[]) {
		this.suggestedDates = suggestedDates;
	}
}
